import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Button, Space, Radio, Skeleton, message } from "antd";
import {
  UserOutlined,
  LockOutlined,
  SafetyCertificateOutlined,
} from "@ant-design/icons";
import httpUtil from "../../../utils/httpUtil";

export const User = () => {
  const [form] = Form.useForm(); // 获取form实例
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    const { userName, password } = values;
    const data = {
      userName,
      password,
    };

    // 显示正在登录中的消息
    let hideLoading = message.loading('正在登录中...', 0);
    setLoading(true)


    httpUtil.login(data).then((res) => {
      form.setFieldsValue({
        userName: "",
        password: "",
        role: 0, 
      });
      if(res.success){

        // 关闭正在登录中的消息
        hideLoading();
        setLoading(false)

        // 存储用户信息到本地存储和内存
        localStorage.setItem('userInfo', JSON.stringify(res.user));
        message.success(`欢迎您${res.user.role}:${res.user.full_name} !`);
        switch (res.user.role) {
          case "管理员":
            history.push("/masterhome");
            break;
          case "辅导员":
            history.push("/preceptorhome");
            break;
          case "学生":
            history.push("/studenthome");
            break;
          case "教师":
            history.push("/teacherhome");
            break;
          default:
            break;
        }
      }else{
        // 关闭正在登录中的消息
        hideLoading();
        setLoading(false)
        message.error(res.error)
      }
    });
  };

  return (
    <Form
      form={form}
      name="normal_login"
      className="login-form"
      onFinish={onFinish}
    >
      <Form.Item
        name="userName"
        rules={[
          {
            required: true,
            message: "请输入您的账号!",
          },
        ]}
      >
        <Input
          prefix={<UserOutlined className="site-form-item-icon" />}
          placeholder="账号"
        />
      </Form.Item>

      <Form.Item
        name="password"
        rules={[
          {
            required: true,
            message: "请输入您的密码!",
          },
        ]}
      >
        <Input.Password
          prefix={<LockOutlined className="site-form-item-icon" />}
          type="password"
          placeholder="密码"
        />
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          style={{ width: "100%", marginTop: 20 }}
          loading={loading}
        >
          登陆
        </Button>
      </Form.Item>
    </Form>
  );
};
